package br.com.texeratx.boardgametimeapp.domain.usecases.games

import br.com.texeratx.boardgametimeapp.data.model.game.UpdateGameRequest
import br.com.texeratx.boardgametimeapp.data.repository.GameRepository
import br.com.texeratx.boardgametimeapp.ui.screens.games.model.GameUI

class UpdateGameUseCase(
    private val repository: GameRepository
) {
    suspend operator fun invoke(
        gameId: Long,
        request: UpdateGameRequest
    ): Result<GameUI> {
        return repository.updateGame(gameId, request).map { dto ->
            GameUI(
                id = dto.id,
                name = dto.name,
                imageUrl = dto.imageUrl ?: dto.thumbnailUrl,
                minPlayers = dto.minNumberOfPlayers,
                maxPlayers = dto.maxNumberOfPlayers,
                duration = dto.gameDuration,
                categoryId = dto.gameCategoryId,
                category = dto.categoryName,
                modeId = dto.gameModeId,
                mode = dto.modeName,
                bggUrl = dto.bggUrl,
                manualUrl = dto.manualUrl,
                spotifyUrl = dto.spotifyUrl,
                matchesPlayed = dto.matchesPlayed,
                clanId = dto.clanId
            )
        }
    }
}

